import businessInfo from './businessInfo'

export * from './businessInfo'
export default businessInfo
